var map = {
	"./pr-1.png": "49e2",
	"./pr-2.png": "3133",
	"./pr-3.png": "f5ec",
	"./pr-4.png": "40a8",
	"./pr-5.png": "4693",
	"./pr-6.png": "ae04",
	"./pr-7.png": "0495"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bed";